import { model as i18n } from '!/i18n'
import { register } from '!/repository'
import { api, type TvShowUpdateObj } from '@setplex/tria-api'
import { combine, createEvent, sample, type Store } from 'effector'
import { produce } from 'immer'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { extendMediaItemByLabelPrice } from '~/shared/tools'
import { type CurrentTvShowWithPriceFormatted } from './index.h'
import { formatCategoryWithShowsToUi, formatCurrentShow } from './lib'

// *
// * EVENTS
// *

export const loadTvShow = createEvent<{
  tvShowId: number
}>()
export const updateTvShow = createEvent<TvShowUpdateObj>()

// *
// * CONNECTIONS
// *

sample({
  clock: loadTvShow,
  target: api.tvshows.getTvShowFx,
})

sample({
  clock: updateTvShow,
  fn: produce((draft) => {
    draft.favorite = !draft.favorite
  }),
  target: api.tvshows.updateTvShowFx,
})

// *
// * STORES
// *

// store with slightly adjusted current tv show
export const $currentShow: Store<CurrentTvShowWithPriceFormatted | null> =
  combine(
    api.tvshows.$currentTvShow,
    ssePurchasesModel.$tvShow,
    i18n.$t,
    (current, adjust, { t }) =>
      current ? formatCurrentShow({ current, adjust, t }) : null
  )

export const $infiniteShowsFormatted = combine(
  api.tvshows.$infiniteShowsCategory,
  ssePurchasesModel.$tvShow,
  i18n.$t,
  (data, adjust, { t }) => formatCategoryWithShowsToUi(data, adjust, t)
)

export const $infiniteShowsTitle: Store<string> = combine(i18n.$t, ({ t }) =>
  t('all')
)

export const $lastAddedTvShowsFormatted = combine(
  api.tvshows.$lastAddedTvShows,
  ssePurchasesModel.$tvShow,
  (tvShows, adjust) =>
    tvShows.map((tvShow) => extendMediaItemByLabelPrice(adjust(tvShow)))
)

// GET /v3/tvshows/categories

// *
// * SKIN
// *

register(updateTvShow, 'shows/updateTvShow')
